export const REGULAR = "regular";
export const SUPPLY_CHAIN = "supply-chain";
export const MIXED = "mixed";
